import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'lib-sendungs-detail-lib',
  template: `
    <p>
      sendungs-detail-lib works!
    </p>
  `,
  styles: [
  ]
})
export class SendungsDetailLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
